import styled from 'styled-components';
import Link from 'next/link';
import { MediaQueryBreakpoints } from '@rockalingua/ui';

export const StyledLink = styled(Link)`
  @media only screen and (max-width: ${MediaQueryBreakpoints.xsm}px) {
    align-self: center;
  }
`;
